import { QueryKeysEnum } from '@/enums';
import {
  DefaultEntity,
  SequencingPartnerEntity,
  SequencingPartnerParams,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class SequencingPartnerService extends BaseService<
  'sequencingPartner',
  SequencingPartnerEntity,
  DefaultEntity
> {
  constructor() {
    super(QueryKeysEnum.SEQUENCING_PARTNER);
  }

  getSequencingPartners = (
    params?: SequencingPartnerParams,
  ): Promise<SequencingPartnerEntity[]> => {
    return APIService.get(this.path + '/all', { params });
  };
}
export const sequencingPartnerService = new SequencingPartnerService();
